import Model from './model.js';
import FileInfo from './fileInfo.js';
export default class Archive extends Model
{
    constructor(id, personId, fileName = null, file=null){ 
        super()
        this.id                 = id ?? 0;
        this.personId           = personId;
        this.fileName           = fileName;
        this.file               = file ?? new FileInfo();

        this.init()
    }
    
    setBinaryFile(binaryFile){
        if (!this.file || typeof this.file !== 'object') this.file = new FileInfo();
        this.file.binaryFile = binaryFile ?? null;
    }

    update(data){
        Object.assign(this, data)
    }

    mapToCreate(){
        let formData = new FormData();
        formData.append('personId', this.personId ?? null);
        formData.append('fileNameId', this.fileName?.value ?? null)
        formData.append('description', this.file?.description ?? null)
        if(this.file?.binaryFile) formData.append('file', this.file.binaryFile);

        return formData;
    }
}

